module.exports = __webpack_public_path__ + "static/media/blueCheckbox.b8125225.svg";